<mat-toolbar [ngStyle]="{ 'background-color': colour }" text-contrast [backgroundColor]="colour">
  <button
    color="secondary"
    mat-button
    *ngIf="canMoveAndResize"
    class="mat-mdc-button"
    (click)="toggleLock()"
    matTooltip="Lock to prevent editing"
    aria-label="Lock to prevent editing"
  >
    <mat-icon text-contrast [backgroundColor]="colour">lock_outline</mat-icon>
    <span> Lock </span>
  </button>

  <button
    color="secondary"
    mat-button
    *ngIf="!canMoveAndResize"
    class="mat-mdc-button"
    (click)="toggleLock()"
    matTooltip="Unlock to allow editing"
    aria-label="Unlock to allow editing"
  >
    <mat-icon text-contrast [backgroundColor]="colour">lock_open</mat-icon>
    <span> Unlock </span>
  </button>

  <button
    color="secondary"
    mat-button
    id="widget_menu_open"
    class="mat-mdc-button"
    [matMenuTriggerFor]="addWidgetMenu"
    matTooltip="Add widget"
    aria-label="Add Widget"
  >
    <mat-icon text-contrast [backgroundColor]="colour">add</mat-icon>
    <span>Add Widget</span>
  </button>
  <mat-menu #addWidgetMenu="matMenu">
    <div *ngFor="let widgetgroup of widgets; let i = index">
      <button *ngFor="let widget of widgetgroup" mat-menu-item (click)="addItem(widget)">{{ widget.name }}</button>
      <mat-divider *ngIf="i < widgets.length - 1"></mat-divider>
    </div>
  </mat-menu>

  <span style="flex: 1 1 auto;"></span>

  <button
    *ngIf="canMoveAndResize && layout?.length > 0"
    color="secondary"
    mat-button
    class="mat-mdc-button"
    (click)="btnRemoveAllWidgets()"
    matTooltip="Delete all widgets"
    aria-label="Delete all widgets"
  >
    <mat-icon text-contrast [backgroundColor]="colour">delete</mat-icon>
    <span> Delete All Widgets </span>
  </button>
</mat-toolbar>
